module.exports = __webpack_public_path__ + "static/media/contact.a42a08ba.svg";